import { getMessages } from '../../../../../../../../store/constants';

export const BOARD_EMPTY_DUMMY_TITLE = getMessages().getText('board_settings.info.empty.title');
export const BOARD_EMPTY_DUMMY_TEXT = getMessages().getText('board_settings.info.empty.text');
